import FormattedDateTime from 'I18n/components/FormattedDateTime';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import { FLOW_BY_REVISION_TIMESTAMP_FIELD_NAME, GET_FLOW_BY_REVISION_TIMESTAMP } from 'automation-ui-canvas/containers/enrollment-history/utils/flowByRevisionQueries';
import { useQuery } from 'data-fetching-client';
import { jsx as _jsx } from "react/jsx-runtime";
const CurrentRevisionDateTime = ({
  flowId,
  timestamp,
  format = 'lll'
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_FLOW_BY_REVISION_TIMESTAMP, {
    variables: {
      flowId,
      revisionTimestamp: timestamp
    }
  });
  if (loading) {
    return /*#__PURE__*/_jsx(SkeletonText, {});
  }
  if (error || !data) {
    return /*#__PURE__*/_jsx(MissingLabel, {
      type: "revision"
    });
  }
  const flowRevision = data[FLOW_BY_REVISION_TIMESTAMP_FIELD_NAME];
  const flow = flowRevision.flow;
  const updateMetadata = flow.updateMetadata;
  return /*#__PURE__*/_jsx(FormattedDateTime, {
    value: updateMetadata.updatedAt,
    format: format,
    type: "portalTz"
  });
};
export default CurrentRevisionDateTime;